import { getUrlLocale, getUrlParameter } from '@/helpers/url'
import URL from 'url-parse'

const VALID_DOMAINS = [
  'zavamed\\.com',
  'zavasrv\\.com',
  'superdrug\\.com',
  'dred\\.com',
  'asda\\.com'
]

const VALID_DOMAIN_REGEX = new RegExp('^([a-z0-9\\-\\.]*\\.)?(' + VALID_DOMAINS.join('|') + ')$')

export function isTargetSafe (redirectUri = '') {
  if (redirectUri) {
    const url = new URL(redirectUri)
    if (url.protocol !== 'https:') {
      return false
    }
    return VALID_DOMAIN_REGEX.test(url.hostname)
  }
  return false
}

export function redirect (redirectUri = getUrlParameter('redirect')) {
  if (redirectUri && isTargetSafe(redirectUri)) {
    const gclid = getUrlParameter('gclid')
    if (gclid) {
      window.location.assign(`${redirectUri}?gclid=${gclid}`)
    } else {
      window.location.assign(redirectUri)
    }
  } else {
    let urlLocale = ''
    if (getUrlLocale()) {
      urlLocale = `/${getUrlLocale()}`
    }

    const accountUrl = window.location.search ? `${window.location.origin}${urlLocale}/account/${window.location.search}` : `${window.location.origin}${urlLocale}/account/`
    window.location.assign(accountUrl)
  }
}
